/* Kleurbolletje op een productkaart: bij hover wisselt de hoofdfoto van de
   kaart naar de foto van die kleur (data-image op het bolletje, gezet in
   snippets/v2-product-card.liquid). Bij het verlaten van de kaart komt de
   eigen foto terug. Alleen op apparaten met een echte muis; op touch blijft
   een tik op het bolletje gewoon de link naar die kleur. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

  function hoofdfoto(kaart) {
    return kaart.querySelector('.product-image img:not(.image-hover)');
  }

  function toon(kaart, bron) {
    var img = hoofdfoto(kaart);
    if (!img || !bron) return;
    if (img.dataset.eigenSrc === undefined) {
      img.dataset.eigenSrc = img.getAttribute('src') || '';
      img.dataset.eigenSrcset = img.getAttribute('srcset') || '';
    }
    if (img.getAttribute('src') === bron) return;
    img.removeAttribute('srcset');
    img.setAttribute('src', bron);
    kaart.classList.add('swatch-preview');
  }

  function herstel(kaart) {
    var img = hoofdfoto(kaart);
    if (!img || img.dataset.eigenSrc === undefined) return;
    img.setAttribute('src', img.dataset.eigenSrc);
    if (img.dataset.eigenSrcset) img.setAttribute('srcset', img.dataset.eigenSrcset);
    kaart.classList.remove('swatch-preview');
  }

  // Foto's van de andere kleuren alvast ophalen zodra de muis op de kaart komt,
  // zodat de wissel bij hover over een bolletje direct is.
  function voorladen(kaart) {
    if (kaart.dataset.swatchesGeladen) return;
    kaart.dataset.swatchesGeladen = '1';
    kaart.querySelectorAll('.swatches .swatch[data-image]').forEach(function (s) {
      var i = new Image(); i.src = s.dataset.image;
    });
  }

  document.addEventListener('mouseover', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var kaart = el.closest('.product-card');
    if (!kaart) return;
    voorladen(kaart);
    var bolletje = el.closest('.swatches .swatch[data-image]');
    if (bolletje) toon(kaart, bolletje.dataset.image);
  });

  document.addEventListener('mouseout', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var kaart = el.closest('.product-card');
    if (!kaart) return;
    if (e.relatedTarget && kaart.contains(e.relatedTarget)) return;
    herstel(kaart);
  });
})();
